import Vue from 'vue'
import DSPCounter from '@/vendor/DSPCounter'

Vue.use(DSPCounter, {
  env: process.env.NODE_ENV,
  scriptSrc: '//counter.reddigital.ru/DSPCounter.js',
  debug: process.env.NODE_ENV !== 'production',
  defaultConfig: {
    site_area: 'fZV9pf9m',
    sid: 224772,
    user_id: '',
    lead_id: '',
    order_sum: ''
  }
})
